export function SectionHeading({ eyebrow, title, text, align = "left" }) {
  return (
    <div className={`section-heading section-heading--${align}`}>
      {eyebrow ? <span className="section-eyebrow">{eyebrow}</span> : null}
      <h2>{title}</h2>
      {text ? <p>{text}</p> : null}
    </div>
  );
}
